<script>
export default {
  computed: {
    period() {
      let month = this.$moment(this.$route.query.month, 'MM').format('MM')
      let periodFrom = `${this.$route.query.year}-${month}`
      let periodTo = `${this.$route.query.year}-${month}`
      return {
        from: {
          ge: this.$moment(periodFrom, 'YYYY-MM')
            .startOf('month')
            .format('YYYY-MM-DD'),
        },
        to: {
          le: this.$moment(periodTo, 'YYYY-MM')
            .endOf('month')
            .format('YYYY-MM-DD'),
        },
      }
    },
  },
}
</script>
